import type {TemplateNode} from '@/uptk/core/components/moduleEntity/template/templateTypes';
import type {Expression} from '@/uptk/core/components/moduleEntity/template/templateBehavior';
import type {ScreenBindingProposal} from './templateScreenBindings';
import type {DesignModuleSpecJson} from '../data/contracts';
import {entitiesOf,replaceNode,visit} from './templateBindings';

/** Search only displayed scalar fields of one unambiguous, nearby native register.
 * It never searches the prototype samples or a hidden/server field. */
export function proposeCollectionSearch(spec:DesignModuleSpecJson,root:TemplateNode):ScreenBindingProposal[]{
 if(root.type!=='el')return [];
 const searches:{path:(string|number)[];node:Extract<TemplateNode,{type:'el'}>}[]=[],repeats:{path:(string|number)[];node:Extract<TemplateNode,{type:'repeat'}>}[]=[];
 const walk=(node:TemplateNode,path:(string|number)[])=>{
  if(node.type==='repeat'){if(node.item.type==='el')repeats.push({node,path});return;}
  if(node.type!=='el')return;
  if(node.tag==='input'&&node.attrs?.type==='search'&&!node.input)searches.push({node,path});
  node.children.forEach((child,index)=>walk(child,[...path,'children',index]));
 };walk(root,[]);
 let next:TemplateNode=root;const descriptions:string[]=[];
 for(const [index,search] of searches.entries()){
  let choices=repeats;
  for(let length=search.path.length-2;length>=0;length-=2){const prefix=search.path.slice(0,length),nearby=repeats.filter(repeat=>prefix.every((part,i)=>repeat.path[i]===part));if(nearby.length){choices=nearby;break;}}
  if(choices.length!==1)continue;
  const repeat=choices[0];if(repeat.node.item.type!=='el'||repeat.node.item.show)continue;
  const fields=new Set<string>();visit(repeat.node.item,node=>{
   if(node.type==='field'&&node.entity===repeat.node.source.entity&&node.scope==='item'&&node.field&&entitiesOf(spec)[node.entity]?.fields.some(field=>field.name===node.field&&['text','textarea','email','select','radio'].includes(field.type)))fields.add(node.field);
  });
  if(!fields.size||fields.size>6)continue;
  const state='register_search_'+index;if(Object.prototype.hasOwnProperty.call(root.state??{},state))continue;
  const expressions:Expression[]=[...fields].map(field=>({op:'contains',args:[{bind:{entity:repeat.node.source.entity,field,scope:'item'}},{state}]}));
  const when=expressions.reduce((left,right)=>({op:'or',args:[left,right]}));
  next=replaceNode(next,search.path,{...search.node,input:{state}});
  next=replaceNode(next,repeat.path,{...repeat.node,item:{...repeat.node.item,show:{when}}});
  if(next.type==='el')next.state={...next.state,[state]:''};
  descriptions.push(repeat.node.source.entity+': '+[...fields].join(', '));
 }
 return descriptions.length?[{path:[],node:next,sample:'search',context:descriptions.join(' / '),confidence:1,reason:'field'}]:[];
}
